export const urlParseMixin = {
  methods: {
    urlParseMixin_combine (start, end) {
      if (!start || !end) {
        return null;
      }
      return start.replace(/\/?$/, '/') + end;
    }
  }
}